/*
 * Naming of EU Countries in this file is based on:
 * https://beta.e-justice.europa.eu/35981/FI/public_documents_forms
 */
export enum Country {
  AUSTRIA = 'AUSTRIA',
  BELGIUM = 'BELGIUM',
  BULGARIA = 'BULGARIA',
  CROATIA = 'CROATIA',
  CYPRUS = 'CYPRUS',
  CZECH_REPUBLIC = 'CZECH_REPUBLIC',
  DENMARK = 'DENMARK',
  ESTONIA = 'ESTONIA',
  FINLAND = 'FINLAND',
  FRANCE = 'FRANCE',
  GERMANY = 'GERMANY',
  GREECE = 'GREECE',
  HUNGARY = 'HUNGARY',
  IRELAND = 'IRELAND',
  ITALY = 'ITALY',
  LATVIA = 'LATVIA',
  LITHUANIA = 'LITHUANIA',
  LUXEMBOURG = 'LUXEMBOURG',
  MALTA = 'MALTA',
  NETHERLANDS = 'NETHERLANDS',
  POLAND = 'POLAND',
  PORTUGAL = 'PORTUGAL',
  ROMANIA = 'ROMANIA',
  SLOVAKIA = 'SLOVAKIA',
  SLOVENIA = 'SLOVENIA',
  SPAIN = 'SPAIN',
  SWEDEN = 'SWEDEN',
}
